import * as JSOG from 'jsog';

export const TOKEN_KEY = 'access_token';
export const CURRENT_USER_KEY = 'current_user';
export const REMEMBER_ME_KEY = 'remember_me';

/**
 * Manage how the Access Tokens are being stored and retrieved from storage.
 *
 * Current implementation stores to localStorage. Local Storage should always be
 * accessed through this instance.
 **/
export const StorageService = {
  getToken() {
    return localStorage.getItem(TOKEN_KEY);
  },

  saveToken(accessToken) {
    localStorage.setItem(TOKEN_KEY, accessToken);
  },

  removeToken() {
    localStorage.removeItem(TOKEN_KEY);
  },

  getRememberMe() {
    return localStorage.getItem(REMEMBER_ME_KEY);
  },

  saveRememberMe(rememberMe) {
    localStorage.setItem(REMEMBER_ME_KEY, rememberMe);
  },

  removeRememberMe() {
    localStorage.removeItem(REMEMBER_ME_KEY);
  },

  getCurrentUser() {
    return JSOG.decode(JSON.parse(localStorage.getItem(CURRENT_USER_KEY)));
  },

  saveCurrentUser(user) {
    localStorage.setItem(CURRENT_USER_KEY, JSON.stringify(JSOG.encode(user)));
  },

  removeCurrentUser() {
    localStorage.removeItem(CURRENT_USER_KEY);
  },

  getLocale() {
    const user = this.getCurrentUser();

    return user ? user.locale : undefined;
  },

  setLocale(locale) {
    const user = this.getCurrentUser() || {};

    user.locale = locale;

    this.saveCurrentUser(user);
  },
};
